// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_2fce59","prosConsContainer":"_98a128","prosConsTitle":"_fecd1c","proConText":"_6ff95e","iconCons":"_7379cc","iconPros":"_8b11ef","prosConsLink":"_8e3027"};